import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

const estrategia = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/estrategia`,
    state: {
        estrategias: []
    }
}).get({
    action: "get_estrategias",   
    onSuccess: (state, payload) => {
        state.estrategias = payload.data;
    }
}).get({
    action: "get_estrategiaspilar",
    path: function (obj) {
        return `/pilar/${obj.idpilar}`;
    },
    onSuccess: (state, payload) => {
        state.estrategias = payload.data;
        state.estrategias.unshift({idestrategia: 0, nombre: 'Todas' , codigo : '', nombrecompleto: 'Todas'}); 
    }
})
    .getStore();
estrategia.getters = {
    gestrategias: state => {
        return state.estrategias
    }
}
export default estrategia;
